import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import "./Navbar.css";
import { useNavigate } from "react-router-dom";
import usePwaInstall from "../../hooks/usePwaInstall";
function AppNavBar({ onToggleSidebar, onLogout }) {
  const navigate = useNavigate();
  const { canInstall, isIOS, devPreview, promptInstall } = usePwaInstall();

  const handleProfile = () => {
    navigate("/profile");
  };

  const handleInstall = async () => {
    if (isIOS) {
      // iOS Safari has no programmatic install; guide the user instead.
      window.alert(
        'To install: tap the Share button, then "Add to Home Screen".'
      );
      return;
    }
    if (!canInstall && devPreview) {
      // Dev preview only — no real install prompt is available in `npm start`.
      window.alert(
        "Install preview (dev only). In a production build this opens the browser's native install dialog."
      );
      return;
    }
    await promptInstall();
  };
  return (
    <div className="navbar-wrapper">
      {/* Mobile sidebar toggle button - positioned absolutely */}
      <Button
        variant="outline-secondary"
        className="d-md-none mobile-sidebar-toggle"
        onClick={onToggleSidebar}
      >
        ☰
      </Button>

      {/* add toggle button on the right side of the navbar for profile and logout*/}
      <Navbar expand="md" className="bg-dark-subtle mobile-navbar">
        <Container fluid className="px-3">
          <Navbar.Brand href="#home" className="mobile-brand">
            Realtor Manager
          </Navbar.Brand>

          {/* show button highlight effect on the profile and logout links */}
          <div className="d-flex align-items-center gap-2">
            {(canInstall || isIOS || devPreview) && (
              <Button
                variant="primary"
                size="sm"
                onClick={handleInstall}
                className="text-nowrap"
                title={
                  devPreview && !canInstall
                    ? "Install app (dev preview — real prompt appears in a production build)"
                    : "Install this app on your device"
                }
              >
                ⬇ Install{devPreview && !canInstall ? " (dev)" : ""}
              </Button>
            )}
            <Button variant="outline-secondary" size="sm" onClick={handleProfile}>
              Profile
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={onLogout}>
              Logout
            </Button>
          </div>

          {/* <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav"> */}
          {/* <Nav className="me-auto"> */}
          {/* <Nav.Link href="#home">Home</Nav.Link>
              <Nav.Link href="#link">Link</Nav.Link> */}
          {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
                <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2">
                  Another action
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.4">
                  Separated link
                </NavDropdown.Item>
              </NavDropdown> */}

          {/* </Nav> */}
          {/* </Navbar.Collapse> */}
        </Container>
      </Navbar>
    </div>
  );
}

export default AppNavBar;
